<template>

  <!-- start::component container -->
  <div id="page-settings-sync">

    <!-- start::title -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="12">
        <h2 class="breadcrumb">Προγραμματισμένες εργασίες</h2>
      </vs-col>
    </vs-row>
    <!-- end::title -->

    <!-- start::section schedule -->
    <div class="vx-card p-6">
      <div class="vx-row">
        <!-- start::schedule column -->
        <div class="vx-col md:w-1/2 w-full">
          <!-- start::section title -->
          <div class="flex items-end mb-3">
            <feather-icon icon="ClockIcon" class="mr-2" svgClasses="w-5 h-5"/>
            <h4 class="leading-none font-medium text-primary">Δημιουργία</h4>
          </div>
          <!-- end::section title -->
          <p>
            Ακολουθείστε τα παρακάτω βήματα για δημιουργείστε μια προγραμματισμένη εργασία.
          </p>
          <vs-divider/>
          <validation-observer v-slot="{ invalid, touched }">


            <!-- start::field scenario -->
            <div class="vx-row mt-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Εργασία ανά: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" immediate v-slot="{ errors }">

                  <v-select :clearable="true" label="name" v-model="selectedScenario"
                            :options="scenarios" @input="defineExtraStep"/>
                  <span>{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <!-- end::field scenario -->

            <!-- start::field jobs -->
            <div v-if="selectedScenario && jobs(selectedScenario.id).length > 0" class="vx-row mt-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Είδος εργασίας: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" immediate v-slot="{ errors }">

                  <v-select :clearable="true" label="name" v-model="selectedJob"
                            :options="jobs(selectedScenario.id)" @input="defineExtraStep"/>
                  <span>{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <!-- end::field jobs -->

            <!--start::field dates -->
            <div v-if="selectedScenario && selectedJob && selectedJob.hasDate" class="vx-row mt-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Ποια ημέρα: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" immediate v-slot="{ errors }">
                  <v-select :clearable="true" v-model="selectedDate" label="name"
                            :options="dates" @input="defineExtraStep"/>
                  <span>{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>

            <!--end::field dates -->

            <!--start::field dates -->
            <div v-if="selectedScenario && selectedJob && selectedJob.hasDateNumber" class="vx-row mt-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Ποια ημέρα+: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" immediate v-slot="{ errors }">
                  <v-select :clearable="true" v-model="selectedDateNumber" label="name"
                            :options="dayNumbers" @input="defineExtraStep"/>
                  <span>{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <!--end::field dates -->

            <!--start::field time -->
            <div v-if="selectedScenario && selectedJob && selectedJob.hasTime" class="vx-row mt-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Ποια ώρα: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" immediate v-slot="{ errors }">
                  <v-select :clearable="true" v-model="selectedHour" label="value"
                            :options="hours" @input="defineExtraStep"/>
                  <span>{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <!--end::field dates -->

            <!-- start::field minute -->
            <div v-if="selectedScenario && selectedJob && selectedJob.hasMinute" class="vx-row mt-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Σε ποιο λεπτό: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" immediate v-slot="{ errors }">
                  <v-select :clearable="true" v-model="selectedMinute" label="name"
                            :options="minutes" @input="defineExtraStep"/>
                  <span>{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <!-- end::field minute -->

            <!-- start::categories -->
            <!--
             Η επιλογή της κατηγορίας εμφανίζεατι στο τέλος των βημάτων ως εναλλακτική επιλογή.
            -->
            <div class="vx-row mt-6" :class="extraStep  ? 'd-none' : ''">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Κατηγορία(ες):<sup class="text-primary">*</sup>
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="intelli_actions">
                  <vs-button @click="selectedCategories = [...categories]" type="flat">Επιλογή όλων</vs-button>
                  <vs-button @click="selectedCategories = []" type="flat">Εκκαθάριση όλων</vs-button>
                </div>
                <v-select :clearable="true" label="name" :multiple="true" v-model="selectedCategories"
                          :options="categories"/>
              </div>
            </div>
            <!-- end::categories -->

            <!-- start::categories -->
            <!--
             Η επιλογή της κατηγορίας εμφανίζεατι στο τέλος των βημάτων ως εναλλακτική επιλογή.
            -->
            <div class="vx-row mt-6" :class="extraStep  ? 'd-none' : ''">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Μάρκα(ες):<sup class="text-primary">*</sup>
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="intelli_actions">
                  <vs-button @click="selectedBrands = [...brands]" type="flat">Επιλογή όλων</vs-button>
                  <vs-button @click="selectedBrands = []" type="flat">Εκκαθάριση όλων</vs-button>
                </div>
                <v-select :clearable="true" label="manufacturer" :multiple="true" v-model="selectedBrands"
                          :options="brands"/>
              </div>
            </div>
            <!-- end::categories -->

            <!-- start::categories -->
            <!--
             Η επιλογή της κατηγορίας εμφανίζεατι στο τέλος των βημάτων ως εναλλακτική επιλογή.
            -->
            <div class="vx-row mt-6" :class="extraStep  ? 'd-none' : ''">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Υποκατηγορία(ες):<sup class="text-primary">*</sup>
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="intelli_actions">
                <vs-button @click="selectedGroups = [...groups]" type="flat">Επιλογή όλων</vs-button>
                <vs-button @click="selectedGroups = []" type="flat">Εκκαθάριση όλων</vs-button>
                </div>
                <v-select :clearable="true" label="group" :multiple="true" v-model="selectedGroups"
                          :options="groups"/>
              </div>
            </div>


            <div class="vx-row mt-6" v-if="dynamicEnabled">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Ελάχιστο ποσοστό διαφοράς
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" name="minimum_percentage_difference" v-model="minimum_percentage_difference" />
              </div>
            </div>

            <div class="vx-row mt-6" v-if="dynamicEnabled">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Μέγιστο ποσοστό διαφοράς
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" name="maximum_percentage_difference" v-model="maximum_percentage_difference" />
              </div>
            </div>

            <div class="vx-row mt-6" v-if="dynamicEnabled">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Ελάχιστο Ποσοστό Παρομοίου Αποθέματος
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" name="minimum_similar_inventory_percentage" v-model="minimum_similar_inventory_percentage" />
              </div>
            </div>

            <div class="vx-row mt-6" v-if="dynamicEnabled">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Αυξομείωση Τιμής Ασφαλείας (%)
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" name="safe_price_modifier" v-model="safe_price_modifier" />
              </div>
            </div>

            <div class="vx-row mt-6" v-if="dynamicEnabled">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Επιλεγμένη πηγή για dynamic pricing
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <v-select :clearable="false" label="name" :multiple="false" v-model="selectedSource"
                          :options="sources" :reduce="loc => loc.id" />
              </div>
            </div>
            <!-- end::categories -->

            <div class="vx-row mt-6" v-if="dynamicEnabled">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Βήμα πτώσης
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" name="increment" v-model="increment" />
              </div>
            </div>

            <div class="vx-row mt-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Αποστολή Αποτελεσμάτων (email)
                </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" name="email" v-model="email" />
              </div>
            </div>

            <!-- start::info text for categories -->
            <div class="vx-row mt-6" :class="extraStep ? 'd-none' : '' ">
              <div class="vx-col w-full">
                <span class="text-primary">
                  *: Επιλέξτε μια ή περισσότερες κατηγορίες/μάρκες/groups προϊόντων.
                </span>
              </div>
            </div>
            <!-- start::info text for categories -->

            <!-- start::display command description -->
            <div v-if="extraStep === false" class="vx-row mt-6">
              <div class="vx-col w-full">
                Δημιουργία προγραμματισμένης εργασίας:
                <strong>
                  <br>
                  <span v-if="selectedJob">
                  {{ `${selectedJob.description}` }}
                </span>
                  <span v-if="selectedMinute">
                    {{ `${selectedMinute.name} λεπτό.` }}
                  </span>
                  <span v-if="selectedDate && selectedHour">
                    {{ `${selectedDate.name} ${selectedHour.value}` }}
                  </span>
                </strong>
              </div>
            </div>
            <!-- end::display command description -->

            <!-- start::submit button -->
            <div class="vx-row">
              <div class="vx-col">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button @click="resetSelectedFields" class="ml-auto mt-2">Καθαρισμός</vs-button>
                </div>
              </div>
              <div class="vx-col">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button :disabled="invalid" class="ml-auto mt-2" @click="addJob">
                    Προσθήκη
                  </vs-button>
                </div>
              </div>
            </div>
            <!-- end::submit button -->
          </validation-observer>
        </div>
        <!-- end::schedule column -->
        <!-- start::schedule list -->
        <div class="vx-col md:w-1/2 w-full mt-20 md:mt-0">
          <div class="vx-row">
            <div class="flex items-end mb-3">
              <feather-icon icon="ClockIcon" class="mr-2" svgClasses="w-5 h-5"/>
              <h4 class="leading-none font-medium text-primary">Υπάρχουσες εργασίες</h4>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col">
              <vs-table :data="scheduleJobs">

                <!-- start::thead -->
                <template slot="thead">
                  <vs-th>Περιγραφή εργασίας</vs-th>
                  <vs-th></vs-th>
                </template>
                <!-- end::thead -->

                <!-- start::data slot -->
                <template slot-scope="{data}">
                  <vs-tr :key="indexTr" v-for="(tr, indexTr) in data">
                    <vs-td :data="data[indexTr].command">
                      <span v-if="data[indexTr].command === 'hourly' ">Αυτόματη εκτέλεση εργασίας κάθε μια ώρα.</span>
                      <span v-if="data[indexTr].command === 'everyTwoHours' ">Αυτόματη εκτέλεση εργασίας κάθε δύο (2) ώρες.</span>
                      <span v-if="data[indexTr].command === 'everyThreeHours' ">Αυτόματη εκτέλεση εργασίας κάθε τρεις (3) ώρες.</span>
                      <span v-if="data[indexTr].command === 'everyFourHours' ">Αυτόματη εκτέλεση εργασίας κάθε τέσσερις (4) ώρες.</span>
                      <span v-if="data[indexTr].command === 'everySixHours' ">Αυτόματη εκτέλεση εργασίας κάθε έξι (6) ώρες.</span>
                      <span v-if="data[indexTr].command === 'hourlyAt' ">
                        {{ `Αυτόματη εκτέλεση εργασία κάθε μια ώρα στο ${data[indexTr].minute} λεπτό της ώρας.` }}
                      </span>
                      <span v-if="data[indexTr].command === 'daily' ">
                        {{ `Αυτόματη εκτέλεση εργασίας κάθε μέρα τα μεσάνυχτα.` }}
                      </span>
                      <span v-if="data[indexTr].command === 'dailyAt' ">
                        {{ `Αυτόματη εκτέλεση εργασίας κάθε μέρα και ώρα ${data[indexTr].hour}.` }}
                      </span>
                      <span v-if="data[indexTr].command === 'weekly' ">
                        {{ `Αυτόματη εκτέλεση εργασίας κάθε Kυριακή και ώρα 00:00.` }}
                      </span>
                      <span v-if="data[indexTr].command === 'weeklyOn' ">
                        {{
                          `Αυτόματη εκτέλεση εργασίας κάθε ${dates.find(x => x.value == data[indexTr].date).name} και ώρα ${data[indexTr].hour}.`
                        }}
                      </span>
                      <span v-if="data[indexTr].command === 'monthly' ">
                        {{ `Αυτόματη εκτέλεση εργασίας κάθε μήνα την πρώτη ημέρα` }}
                      </span>
                      <span v-if="data[indexTr].command === 'monthlyOn' ">
                        {{
                          `Αυτόματη εκτέλεση εργασίας κάθε μήνα στης ${data[indexTr].date_number} του μηνός και ώρα ${data[indexTr].hour}.`
                        }}
                      </span>
                      <hr>
                      <template v-if="tr.categories">
                        Η προγραμματισμένη εργασία θα εκτελεστεί μόνο για τις παρακάτω κατηγορίες προϊόντων:
                        <span v-for="category in tr.categories.split(',')" :key="category">
                          <span style="font-weight: bold" v-if="getCategoryName(category)">
                            {{ getCategoryName(category) }},
                          </span>
                        </span>
                        <div style="clear: both;"></div>
                        <hr />
                      </template>

                      <template v-if="tr.brands">
                        Η προγραμματισμένη εργασία θα εκτελεστεί μόνο για τις παρακάτω μάρκες προϊόντων:
                        <span v-for="brand in tr.brands.split(',')"
                              :key="brand">
                            <span style="font-weight: bold;" v-if="brands.find(x => x.manufacturer === brand)">
                              {{ brands.find(x => x.manufacturer === brand).manufacturer }},
                            </span>
                          </span>
                        <div style="clear: both;"></div>
                        <hr>
                      </template>
                      <template v-if="tr.groups">
                        Η προγραμματισμένη εργασία θα εκτελεστεί μόνο για τις παρακάτω ομάδες προϊόντων:
                        <span v-for="group in tr.groups.split(',')"
                              :key="group">
                            <span style="font-weight: bold;" v-if="groups.find(x => x.group === group)">
                              {{ groups.find(x => x.group === group).group }},
                            </span>
                          </span>
                        <div style="clear: both;"></div>
                        <hr>
                      </template>

                      <span style="display: flex; align-items: self-end; margin-top:10px;">
                        <feather-icon icon="InfoIcon" class="inline-flex rounded-full"></feather-icon>&nbsp; Σύνολο Request / φορά: &nbsp;<strong>{{
                          tr.request_needed_time
                        }}</strong>
                      </span>

                      <span style="display: flex; align-items: self-end; margin-top:10px;">
                        <feather-icon icon="InfoIcon" class="inline-flex rounded-full"></feather-icon>&nbsp; Σύνολο Request / μήνα: &nbsp;<strong>{{
                          tr.request_needed
                        }}</strong>
                      </span>


                      <span style="display: flex; align-items: self-end; margin-top:10px;">
                        <feather-icon
                            icon="EditIcon"
                            class="inline-flex rounded-full cursor-pointer"
                            @click="toggleEdit('email')"
                        ></feather-icon>
                        &nbsp; Αποστολή Αποτελεσμάτων: &nbsp;
                        <strong v-if="!isEditing.email">{{ tr.email }}</strong>
                        <input
                            v-if="isEditing.email"
                            v-model="newValues.email"
                        />
                        <button
                            v-if="isEditing.email"
                            @click="saveEdit(tr.id,'email', newValues.email)"
                        >
                          Save
                        </button>
                      </span>

                      <span style="display: flex; align-items: self-end; margin-top:10px;" v-if="dynamicEnabled">
                        <feather-icon
                            icon="EditIcon"
                            class="inline-flex rounded-full cursor-pointer"
                            @click="toggleEdit('safe_price_modifier')"
                        ></feather-icon>
                        &nbsp; Αυξομείωση Τιμής Ασφαλείας (%): &nbsp;
                        <strong v-if="!isEditing.safe_price_modifier">{{ tr.safe_price_modifier }}</strong>
                        <input
                            v-if="isEditing.safe_price_modifier"
                            v-model="newValues.safe_price_modifier"
                        />
                        <button
                            v-if="isEditing.safe_price_modifier"
                            @click="saveEdit(tr.id,'safe_price_modifier', newValues.safe_price_modifier)"
                        >
                          Save
                        </button>
                      </span>



                      <span style="display: flex; align-items: self-end; margin-top:10px;" v-if="dynamicEnabled">
                        <feather-icon
                            icon="EditIcon"
                            class="inline-flex rounded-full cursor-pointer"
                            @click="toggleEdit('minimumPercentageDifference')"
                        ></feather-icon>
                        &nbsp; Ελάχιστο ποσοστό διαφοράς: &nbsp;
                        <strong v-if="!isEditing.minimumPercentageDifference">{{ tr.minimum_percentage_difference }}</strong>
                        <input
                            v-if="isEditing.minimumPercentageDifference"
                            v-model="newValues.minimumPercentageDifference"
                        />
                        <button
                            v-if="isEditing.minimumPercentageDifference"
                            @click="saveEdit(tr.id,'minimumPercentageDifference', newValues.minimumPercentageDifference)"
                        >
                          Save
                        </button>
                      </span>

                      <span style="display: flex; align-items: self-end; margin-top:10px;" v-if="dynamicEnabled">
                        <feather-icon
                            icon="EditIcon"
                            class="inline-flex rounded-full cursor-pointer"
                            @click="toggleEdit('maximumPercentageDifference')"
                        ></feather-icon>
                        &nbsp; Μέγιστο ποσοστό διαφοράς: &nbsp;
                        <strong v-if="!isEditing.maximumPercentageDifference">{{ tr.maximum_percentage_difference }}</strong>
                        <input
                            v-if="isEditing.maximumPercentageDifference"
                            v-model="newValues.maximumPercentageDifference"
                        />
                        <button
                            v-if="isEditing.maximumPercentageDifference"
                            @click="saveEdit(tr.id,'maximumPercentageDifference',newValues.maximumPercentageDifference)"
                        >
                          Save
                        </button>
                      </span>

                      <!-- Minimum Similar Inventory Percentage -->
                      <span style="display: flex; align-items: self-end; margin-top:10px;" v-if="dynamicEnabled">
                        <feather-icon
                            icon="EditIcon"
                            class="inline-flex rounded-full cursor-pointer"
                            @click="toggleEdit('minimumSimilarInventoryPercentage')"
                        ></feather-icon>
                        &nbsp; Ελάχιστο Ποσοστό Παρομοίου Αποθέματος: &nbsp;
                        <strong v-if="!isEditing.minimumSimilarInventoryPercentage">{{ tr.minimum_similar_inventory_percentage }}</strong>
                        <input
                            v-if="isEditing.minimumSimilarInventoryPercentage"
                            v-model="newValues.minimumSimilarInventoryPercentage"
                        />
                        <button
                            v-if="isEditing.minimumSimilarInventoryPercentage"
                            @click="saveEdit(tr.id,'minimumSimilarInventoryPercentage',newValues.minimumSimilarInventoryPercentage)"
                        >
                          Save
                        </button>
                      </span>

                      <!-- Selected Source -->
                      <span style="display: flex; align-items: self-end; margin-top:10px;" v-if="dynamicEnabled">
                        <feather-icon
                            icon="EditIcon"
                            class="inline-flex rounded-full cursor-pointer"
                            @click="toggleEdit('selectedSource')"
                        ></feather-icon>
                        &nbsp; Επιλεγμένη πηγή: &nbsp;
                        <strong v-if="!isEditing.selectedSource">{{ sources.find(x => x.id == tr.source).name }}</strong>
                        <select
                            v-if="isEditing.selectedSource"
                            v-model="newValues.selectedSource"
                        >
                          <option v-for="source in sources" :key="source.id" :value="source.id">
                            {{ source.name }}
                          </option>
                        </select>
                        <button
                            v-if="isEditing.selectedSource"
                            @click="saveEdit(tr.id,'selectedSource',newValues.selectedSource)"
                        >
                          Save
                        </button>
                      </span>

                      <!-- Increment -->
                      <span style="display: flex; align-items: self-end; margin-top:10px;" v-if="dynamicEnabled">
                        <feather-icon
                            icon="EditIcon"
                            class="inline-flex rounded-full cursor-pointer"
                            @click="toggleEdit('increment')"
                        ></feather-icon>
                        &nbsp; Βήμα πτώσης: &nbsp;
                        <strong v-if="!isEditing.increment">{{ tr.increment }}</strong>
                        <input
                            v-if="isEditing.increment"
                            v-model="newValues.increment"
                        />
                        <button
                            v-if="isEditing.increment"
                            @click="saveEdit(tr.id,'increment',newValues.increment)"
                        >
                          Save
                        </button>
                      </span>
                    </vs-td>
                    <vs-td>
                      <vs-button @click="deleteJob(tr)" color="danger" type="border" icon-pack="feather"
                                 icon="icon-trash" size="small"></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
                <!-- end::data slot -->

              </vs-table>
            </div>
          </div>
        </div>
        <!-- end::schedule list -->
      </div>
    </div>
    <!-- end::section schedule -->

  </div>
  <!-- end::component container -->

</template>

<script>

import vSelect from "vue-select";
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Το πεδίο είναι υποχρεωτικό'
});

export default {
  name: "SettingLaravelSync",
  components: {vSelect, ValidationProvider, ValidationObserver},
  data() {
    return {
      isEditing: {
        minimumPercentageDifference: false,
        maximumPercentageDifference: false,
        minimumSimilarInventoryPercentage: false,
        selectedSource: false,
        increment: false,
        safe_price_modifier: false,
        email: false
      },
      newValues: {},
      extraStep: true,
      selectedScenario: null,
      selectedJob: null,
      selectedDate: '',
      selectedDateNumber: '',
      selectedHour: '',
      selectedMinute: '',
      selectedCategories: '',
      selectedBrands: '',
      selectedGroups: '',
      email: null,
      safe_price_modifier: 0,
      minimum_percentage_difference: 0,
      maximum_percentage_difference: 0,
      minimum_similar_inventory_percentage: 0,
      increment: 0.01,
      selectedSource: 1,
      sources: [
        {id:1, name : 'Skroutz'},
        {id:2, name : 'BestPrice'},
        {id:11, name : 'Shopflix'},
      ]
    }
  },
  computed: {
    dynamicEnabled() {
      let xmlOptions = this.$store.getters.getXmlOptions;
      if (Array.isArray(xmlOptions) && xmlOptions.length > 0) {
        let dynamicProcessOption = xmlOptions.find(option => option.key === 'dynamic_process');
        return dynamicProcessOption && dynamicProcessOption.value === "true";
      }
      return false;
    },
    scheduleJobs() {
      return this.$store.getters.getScheduleJobs
    },
    scenarios() {
      return this.$store.getters.getCronScenarios
    },
    jobs() {
      return (scenarioId) => {
        return this.$store.getters.getCronJobs.filter(x => x.scenarioId === scenarioId)
      }
    },
    minutes() {
      return this.$store.getters.getMinutes
    },
    dates() {
      return this.$store.getters.getCronDates
    },
    dayNumbers() {
      return this.$store.getters.getCronDays
    },
    hours() {
      return this.$store.getters.getCronHours
    },
    categories() {
      //return this.$store.getters.getSettingCategories
      return this.$store.getters.getSettingCategories.slice().sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
    brands() {
      //return this.$store.getters.getSettingBrands
      return this.$store.getters.getSettingBrands.slice().sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
    groups() {
      //return this.$store.getters.getSettingGroups
      return this.$store.getters.getSettingGroups.slice().sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
  },
  methods: {
    getCategoryName(categoryId) {
      const category = this.categories.find(x => x.id === parseInt(categoryId));
      return category ? category.name : '';
    },
    toggleEdit(field) {
      this.isEditing[field] = !this.isEditing[field];
      if (!this.isEditing[field]) {
        this.resetValue(field);
      }
    },
    saveEdit(id, field, newValueKey) {
      let payload = {
        id: id,
        field: field,
        newValueKey: newValueKey
      }
      console.log('payload', payload)
      this.$store.dispatch('updateScheduleJobs', payload)
      this.isEditing[field] = false;
    },
    resetValue(field) {
      this.newValues[field] = '';
    },
    defineExtraStep(payload) {
      if (payload) {
        this.extraStep = payload.extraStep
      } else {
        this.extraStep = true
      }
    },
    resetSelectedFields() {
      this.extraStep = true
      this.selectedScenario = null
      this.selectedJob = ''
      this.selectedDate = ''
      this.selectedHour = ''
      this.selectedMinute = ''
      this.selectedDateNumber = ''
      this.selectedSource = 1
      this.email = null
      this.minimum_percentage_difference = 0
      this.maximum_percentage_difference = 0
      this.minimum_similar_inventory_percentage = 0
      this.safe_price_modifier = 0
      this.increment = 0.01
    },
    addJob() {
      console.log('Add cron job')
      let payload = {
        command: this.selectedJob.command,
        description: this.selectedJob.description,
        hasDate: this.selectedJob.hasDate,
        hasDateNumber: this.selectedJob.hasDateNumber,
        hasTime: this.selectedJob.hasTime,
        hasMinute: this.selectedJob.hasMinute,
        date: this.selectedDate ? this.selectedDate.value : '',
        hour: this.selectedHour ? this.selectedHour.value : '',
        minute: this.selectedMinute ? this.selectedMinute.name : '',
        dateNumber: this.selectedDateNumber ? this.selectedDateNumber.name : '',
        productCategories: this.selectedCategories,
        productBrands: this.selectedBrands,
        productGroups: this.selectedGroups,
        minimum_percentage_difference: this.minimum_percentage_difference,
        maximum_percentage_difference: this.maximum_percentage_difference,
        minimum_similar_inventory_percentage: this.minimum_similar_inventory_percentage,
        safe_price_modifier: this.safe_price_modifier,
        source: this.selectedSource,
        increment: this.increment,
        email: this.email,
      }
      this.$store.dispatch('addCronScheduleJob', payload)
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: 'Επιτυχία',
              position: 'top-right',
              text: 'Η εργασία δημιουργήθηκε με επιτυχία.',
            })
            this.resetSelectedFields()
          })
    },
    deleteJob(payload) {

      this.$store.dispatch('deleteCronScheduleJob', payload)
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: 'Επιτυχία',
              position: 'top-right',
              text: 'Η διαγραφή της εργασίας έγινε με επιτυχία.',
            })
          })
    }
  },
  mounted() {
    this.$store.dispatch('fetchScheduleJobs')
    this.$store.dispatch('fetchSettingCategories')
    this.$store.dispatch('fetchSettingBrands')
    this.$store.dispatch('fetchSettingGroups')
    this.$store.dispatch('fetchXmlOptions')
  },
  watch: {
    'tr.minimum_percentage_difference'(newValue) {
      this.newValues.minimumPercentageDifference = newValue;
    },
    'tr.maximum_percentage_difference'(newValue) {
      this.newValues.maximumPercentageDifference = newValue;
    },
    'tr.minimum_similar_inventory_percentage'(newValue) {
      this.newValues.minimumSimilarInventoryPercentage = newValue;
    },
    'tr.safe_price_modifier'(newValue) {
      this.newValues.safe_price_modifier = newValue;
    },
    'tr.email'(newValue) {
      this.newValues.email = newValue;
    },
    'tr.source'(newValue) {
      this.newValues.selectedSource = newValue;
    },
    'tr.increment'(newValue) {
      this.newValues.increment = newValue;
    }
  }
}
</script>

<style scoped>
.d-none {
  display: none;
}

.intelli_actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.vs-button-primary.vs-button-flat {
  border: none !important;
  font-size: 9px;
  text-align: right;
  padding: 0 !important;
}
</style>
